import { Divider, Flex, Popover, ScrollAreaAutosize } from "@mantine/core";
import styled from "styled-components";
import CalendarShiftEvent from "./CalendarShiftEvent";
import dayjs from "dayjs";

const CalendarShowMore = ({
  events,
  setEvents,
  count,
  activeTab,
  setIsModalOpen,
  setSelectedEvent,
  selectedRole,
  opened,
  onOpen,
}: any) => {
  return (
    <>
      <Popover
        width={367}
        styles={{
          dropdown: { height: "356px" },
        }}
        position="bottom-end"
        shadow="md"
        opened={opened}
        zIndex={25}
      >
        <Popover.Target>
          <Wrapper onClick={onOpen} className="rbc-show-more">
            <ShowMoreText>
              <span>{count} tane daha</span>
            </ShowMoreText>
          </Wrapper>
        </Popover.Target>
        <Popover.Dropdown p={24}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "16px",
            }}
          >
            <DateTitle>
              {dayjs(events[0].startTime).format("dddd, MMM DD")}
            </DateTitle>
            <Flex justify={"space-between"} align={"center"}>
              <RoleTitle>{selectedRole.label}</RoleTitle>
              <TotalCount>
                {events.reduce(
                  (total: number, event: any) => total + (event.count || 0),
                  0
                )}
              </TotalCount>
            </Flex>
            <Divider />
            <ShiftEmployeeCountText>
              Vardiya Çalışan Sayıları
            </ShiftEmployeeCountText>
            <ScrollAreaAutosize>
              <div
                style={{
                  height: "190px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {events.map((e: any) => (
                  <CalendarShiftEvent
                    selectedRole={selectedRole}
                    event={e}
                    activeTab={activeTab}
                    setIsModalOpen={setIsModalOpen}
                    setSelectedEvent={setSelectedEvent}
                    setEvents={setEvents}
                  />
                ))}
              </div>
            </ScrollAreaAutosize>
          </div>
        </Popover.Dropdown>
      </Popover>
    </>
  );
};

export default CalendarShowMore;

const Wrapper = styled.div`
  width: 100%;
  padding: 4px 8px;
`;

const ShowMoreText = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 50px;
  height: 24px;
  padding: 4px 8px;
  span {
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    color: #5c26ff;
  }
  &: hover {
    background-color: #eef2ff;
  }
`;

const DateTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #111827;
`;

const TotalCount = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #111827;
`;

const RoleTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #111827;
`;

const ShiftEmployeeCountText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4b5563;
`;
